import React from "react";
import { Check } from "lucide-react";

export function PickOne({ value, onChange, options }) {
  return (
    <ul className="space-y-3" role="radiogroup">
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <li key={opt.value}>
            <button
              type="button"
              onClick={() => onChange(opt.value)}
              role="radio"
              aria-checked={selected}
              className={`w-full flex items-center justify-between gap-4 px-5 py-4 rounded-2xl border text-left transition-all ${
                selected
                  ? "border-qh-rose bg-[#FFE4E6]/40 text-qh-ink"
                  : "border-qh-line bg-white hover:border-qh-ink/40"
              }`}
              data-testid={`pick-${opt.value}`}
            >
              <div>
                <div className="font-medium">{opt.label}</div>
                {opt.hint && (
                  <div className="text-xs text-qh-slate mt-0.5">{opt.hint}</div>
                )}
              </div>
              <span
                className={`h-5 w-5 shrink-0 rounded-full border flex items-center justify-center ${
                  selected ? "border-qh-rose bg-qh-rose" : "border-qh-line"
                }`}
              >
                {selected && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export function PickMany({ value = [], onChange, options, max }) {
  const toggle = (v) => {
    const set = new Set(value);
    if (set.has(v)) set.delete(v);
    else if (!max || set.size < max) set.add(v);
    onChange(Array.from(set));
  };
  return (
    <div className="flex flex-wrap gap-2" role="group">
      {options.map((opt) => {
        const selected = value.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            aria-pressed={selected}
            className={`px-4 py-2 rounded-full border text-sm transition-all ${
              selected
                ? "border-qh-rose bg-qh-rose text-white"
                : "border-qh-line bg-white text-qh-ink hover:border-qh-ink/40"
            }`}
            data-testid={`pickmany-${opt.value}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export function TextField({ value, onChange, placeholder, type = "text", autoFocus }) {
  return (
    <input
      type={type}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
      className="w-full h-14 px-5 rounded-2xl border border-qh-line bg-white text-lg focus:outline-none focus:border-qh-rose focus:ring-2 focus:ring-qh-rose/20 transition-all"
      data-testid="text-field"
    />
  );
}
